export const isAnimation = () => {
  // Check for support first
  if ('IntersectionObserver' in window) {
    let callback = (entries, observer) => {
      entries.forEach((entry) => {
        let numberObjs = entry.target.parentNode.querySelectorAll('.number');
        
        if (entry.isIntersecting) {
          entry.target.classList.add("is-animating");
  
          if(numberObjs) {
            numberObjs.forEach((obj) => {
              animateValue(obj, 0, parseInt(obj.dataset.number), 2000);
            });
          }
  
        } else {
          if (entry.boundingClientRect.top > 0) {
            entry.target.classList.remove("is-animating");
          } else {
          }
        }
      });
    };
  
    let ioObserver = new IntersectionObserver(callback, {
      root: null,
      rootMargin: "0px 0px 0px 0px",
      threshold: 0,
    });
  
    let elements = document.querySelectorAll("[animation]"); // Select all elements
  
    // Add all elements to observer
    elements.forEach((element) => {
      ioObserver.observe(element);
    });

    function animateValue(obj, start, end, duration) {
        let startTimestamp = null;
        const step = (timestamp) => {
          if (!startTimestamp) startTimestamp = timestamp;
          const progress = Math.min((timestamp - startTimestamp) / duration, 1);
          obj.innerHTML = Math.floor(progress * (end - start) + start);
          if (progress < 1) {
            window.requestAnimationFrame(step);
          }
        };
        window.requestAnimationFrame(step);
      }
  }  else {
    let showAllElems = () => {
      let elements = document.querySelectorAll("[animation]");
      elements.forEach((elem) => {
        elem.classList.add("is-animating");
       });
    }
    showAllElems();
  }   
};